import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-container',
    templateUrl: './container.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class ContainerComponent {
}
